/** Canonical platform roles — keep in sync with `shared/user-roles.ts` */
export const UserRole = {
  USER: "USER",
  SELLER: "SELLER",
  PREMIUM_SELLER: "PREMIUM_SELLER",
  STUDENT: "STUDENT",
  ADMIN: "ADMIN",
  PROFESSIONAL: "PROFESSIONAL",
  /** Create jobs, post work, book professionals (with Royalty+ tier where gated) */
  BOOKER: "BOOKER",
  /** Create / manage certificate templates and issuance */
  INSTRUCTOR: "INSTRUCTOR",
} as const;

export const USER_ROLES = { ...UserRole };
